import { ButtonBase } from '@mui/material';
import * as React from 'react';


export default function CustomButton({ title, press, style, textColor, backgroundColor, borderStyle, marginLeft, marginRight, marginTop, height, width, borderRadius, paddingInline, padding, disabled, hoverColor, hoverBackgroundColor, fontSize, className, }) {
    return (
        <>
            <ButtonBase
                className={className || ""}
                style={{
                    padding: padding || 17,
                    paddingInline: paddingInline || 20,
                    fontSize: fontSize || 14,
                    fontWeight: 500,
                    border: borderStyle || "1px solid #EAE8E7",
                    backgroundColor: backgroundColor || "var(--bs-theme-color)",
                    borderRadius: borderRadius || '12px',
                    marginLeft: marginLeft || 0,
                    marginRight: marginRight || 0,
                    marginTop: marginTop || 0,
                    minHeight: height ? height : 44,
                    height: height ? height : 44,
                    width: width && width,
                    cursor: "pointer",
                    transition: hoverBackgroundColor || hoverColor ? 'background-color 0.5s, color 0.5s' : 'none',
                }}
                sx={{
                    // '&:hover': {
                    //     color: hoverColor || textColor,
                    //     backgroundColor: hoverBackgroundColor || backgroundColor,
                    // },
                    color: textColor || 'white',
                    backgroundColor: backgroundColor || "var(--bs-theme-color)",
                    style,
                }}
                disabled={disabled}
                onClick={() => press()}
            >
                {title}
            </ButtonBase>
        </>
    );
}
